<template>
  <b-dropdown
    ref="action-dropdown"
    id="action-dropdown"
    text="Actions"
    class="mr-3 p-0"
    toggle-class="poppins btn btn--export-filter"
    menu-class="m-0 p-0 ml-n4"
    no-caret
    variant="upload"
  >
    <template v-slot:button-content>
      <div class="px-2">
        <span class="svg-icon">
          <v-icon size="18">mdi-dns</v-icon>
        </span>
        <span>Actions</span>
        <span class="svg-icon mr-0 ml-2">
          <v-icon size="18">mdi-chevron-down</v-icon>
        </span>
      </div>
    </template>
    <div class="q-status-menu py-1 w-175px">
      <div
        class="drop-item poppins px-3 mx-3 rounded-lg cursor-pointer bg-hover-light-info"
        v-for="(action, index) in types"
        :key="index"
        @click="() => handleClick(action.url)"
      >
        <div
          class="py-2 w-100 text-left drop-text poppins font-size-sm font-weight-medium"
          :class="[
            { 'mt-2': index === 0 },
            { 'mb-2': index === types.length - 1 },
          ]"
        >
          {{ action.name }}
        </div>
      </div>
    </div>
  </b-dropdown>
</template>

<script>
export default {
  name: "ActionsButton",
  props: ["items", "types", "refresher", "callback"],
  methods: {
    handleClick(url) {
      if (this.callback && this.callback[url]) {
        this.callback[url]();
        return;
      }
      // If we add API-based actions later, we can implement them here
      // similar to the Orders ActionsButton pattern
      // For now, only the callback-driven actions are needed
    },
  },
};
</script>
